import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_any_of_the_following_safety_measures_in_place_9'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_any_of_the_following_safety_measures_in_place_9',
  name: 'Does the facility have any of the following safety measures in place related to ergonomics? ',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'FACILITY_HAS_A_SYSTEM_FOR_IDENTIFYING_EVALUATING_AND_MINIMIZING',
      text: 'Facility has a system for identifying, evaluating and minimizing risks from physically demanding work to prevent work-related injuries and health impacts',
      externalIds: [
        {
          id: 'hs-33--1-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKERS_ARE_ROTATED_TO_REDUCE_EXPOSURE_TO_REPETITIVE_TASKS',
      text: 'Workers are rotated to reduce exposure to repetitive tasks',
      externalIds: [
        {
          id: 'hs-33--1-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKERS_CAN_TAKE_SHORT_ERGONOMIC_BREAKS_DURING_THE_WORK_DAY',
      text: 'Workers can take short ergonomic breaks during the work day',
      externalIds: [
        {
          id: 'hs-33--1-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FACILITY_PROVIDES_ADJUSTABLE_WORKSTATIONS_TO_ACCOMMODATE_INDIVI',
      text: 'Facility provides adjustable workstations to accommodate individual worker needs',
      externalIds: [
        {
          id: 'hs-33--1-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FACILITY_PROVIDES_ADJUSTABLE_EQUIPMENT_TO_ACCOMMODATE_INDIVIDUA',
      text: 'Facility provides adjustable equipment to accommodate individual worker needs',
      externalIds: [
        {
          id: 'hs-33--1-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FACILITY_PROVIDES_TRAINING_ON_ERGONOMIC_FACTORS_AND_GOOD_PRACTI',
      text: 'Facility provides training on ergonomic factors and good practices to prevent and/or reduce injuries',
      externalIds: [
        {
          id: 'hs-33--1-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'FACILITY_HAS_A_SYSTEM_FOR_IDENTIFYING_EVALUATING_AND_MINIMIZING',
                'WORKERS_ARE_ROTATED_TO_REDUCE_EXPOSURE_TO_REPETITIVE_TASKS',
                'WORKERS_CAN_TAKE_SHORT_ERGONOMIC_BREAKS_DURING_THE_WORK_DAY',
                'FACILITY_PROVIDES_ADJUSTABLE_WORKSTATIONS_TO_ACCOMMODATE_INDIVI',
                'FACILITY_PROVIDES_ADJUSTABLE_EQUIPMENT_TO_ACCOMMODATE_INDIVIDUA',
                'FACILITY_PROVIDES_TRAINING_ON_ERGONOMIC_FACTORS_AND_GOOD_PRACTI',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-wor-4',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 16030,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
